import { render, staticRenderFns } from "./roast-select.vue?vue&type=template&id=0f0576f8&"
import script from "./roast-select.vue?vue&type=script&lang=js&"
export * from "./roast-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports